import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IPageData } from '../../../interfaces/page-data';
import { IAppState } from '../../../interfaces/app-state';
import { HttpService } from '../../../services/http/http.service';
import * as PageActions from '../../../store/actions/page.actions';
import { Options } from 'ng5-slider';
// import { Options } from '@angular-slider/ngx-slider';
import Swal from 'sweetalert2'
import swal from 'sweetalert2'
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Spinkit } from 'ng-http-loader';
import { Location } from '@angular/common';
import { BasePageComponent } from '../../base-page';

@Component({
	selector: 'guest-page',
	templateUrl: './geust-page.component.html',
	styleUrls: ['./geust-page.component.scss']
})
export class GeustComponent extends BasePageComponent implements OnInit, OnDestroy {
	pageData: IPageData;
	public spinkit = Spinkit;
	More
	more
	errorMessage
	restoID;
	toggle;
	crossC;
	crossContamination;
	allergenceArray = []
	diestPrefArray = []
	changeColorallergens = [];
	changeColordiet = []
	changeColors = []
	showmenus
	searchText
	token
	userName
	crossCguest
	guestCC
	finalguestCC
	UserCCset
	spiceTollerence = 0;
	selectedAllergence = []
	diestPrefArrayName = []
	allergenceArrayName = []
	allergenceArrayNumbers = []
	UserCondition
	ids;
	tableID;
	userCCDefault = 'No'
	tableids;
	tabledata = [];
	userCC
	// value = 0;
	value: number = 0;
	values: number = 0;
	options: Options = {
		floor: 0,
		ceil: 4
	};


	// options: Options = {
	// 	floor: 0,
	// 	ceil: 4
	// };

	statusClasses = 'not-active';
	statusClass = 'not-active';
	userName_loggedin: any;
	user_Name: any;
	postdata: { allergens: number[]; dietary: number[]; spice_rating_all: any; cross_contamination: any; };

	setActiveClass() {
		if (this.diestPrefArray.length == 0) {
			this.dietRemove()
		} else {
			this.statusClass = 'active';
		}
	}
	setAllergenceActiveClass() {
		if (this.allergenceArray.length == 0) {
			this.AllergensRemove()
		} else {
			this.statusClasses = 'active';
		}

	}
	constructor(store: Store<IAppState>,
		httpSv: HttpService, private router: Router,
		private route: ActivatedRoute,
		private changeDetectorRef: ChangeDetectorRef,
		private _location: Location) {
		//  ,private _Activatedroute:ActivatedRoute
		super(store, httpSv);

		this.pageData = {
			title: '',
			loaded: true,
			breadcrumbs: [{
				title: 'guest',
				route: 'choose-preference'
			}]
		};
	}


	ngOnInit() {
		// this.changeDetectorRef.detach(); 
		this.restoID = sessionStorage.getItem('restoId')
		this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
		this.ids = sessionStorage.getItem('restoIds')
		this.token = sessionStorage.getItem('access_token')
		this.route.queryParams.subscribe(params => {
			this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
			this.tableID = sessionStorage.getItem('tableId')
		});

		this.getAllAllergens(this.restoID);
		this.getAllRestoDietary(this.restoID);
		this.getHideSpiceTollranceCheck(this.restoID);
		if (sessionStorage.getItem('access_token'))
			this.FetchUserPrefernces()
		this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
		// this.changeDetectorRef.detach(); 
		this.allergenceArray = this.httpSv.allergenceArray
		this.diestPrefArray = this.httpSv.diestPrefArray
		this.spiceTollerence = this.httpSv.spiceTollerence
		this.setActiveClass()
		this.setAllergenceActiveClass()
	}


	backClicked() {
		this.router.navigate(['public/resto']
			, {
				queryParams: {
					id: this.ids,
					table_id: this.tableids
				}
			});
		sessionStorage.removeItem('OrderIDGuest');
	}

	private destroyed = false;
	// ngOnDestroy() {
	// 	this.destroyed = true;
	// 	this.store.dispatch(new PageActions.Reset());
	// 	this.changeDetectorRef.detach(); 
	// }

	// triggerChangeDetection() {
	//   if (!this.destroyed) {
	// 	this.changeDetectorRef.detach();
	// 	this.changeDetectorRef.detectChanges();
	// 	this.changeDetectorRef.detach();
	//   }
	// }
	AllergensRemove() {
		this.allergenceArray = []
		this.changeColorallergens = [];
		this.allergenceArrayName = []
		this.statusClasses = 'not-active';
	}
	dietRemove() {
		this.diestPrefArray = []
		this.changeColordiet = []
		this.diestPrefArrayName = []
		this.statusClass = 'not-active';
	}

	toggleSelectedAllergence(item, itemAll, event) {
		if (this.allergenceArray.indexOf(item) == -1) {
			this.allergenceArray.push(item)
			this.allergenceArrayName.push(itemAll)
		} else {
			const index = this.allergenceArray.indexOf(item)
			this.allergenceArray.splice(index, 1)
			this.allergenceArrayName.splice(index, 1)
		}
	}
	parsedDiestPrefArray = []
	addAllDiet(item, itemAll, event) {
		if (this.diestPrefArray.indexOf(item) == -1) {
			this.diestPrefArray.push(item)
			this.diestPrefArrayName.push(itemAll)
		} else {
			const index = this.diestPrefArray.indexOf(item)
			this.diestPrefArray.splice(index, 1)
			this.diestPrefArrayName.splice(index, 1)
		}

		// code to convert the array of string to array of numbers
		this.parsedDiestPrefArray = [];
		this.diestPrefArray.forEach((item) => {
			this.parsedDiestPrefArray.push(Number(item));
		})
	}

	logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
				if (response['status'] == true) {
					sessionStorage.clear();
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
					});
					window.location.reload()
				}
			}, (err: HttpErrorResponse) => {
				this.errorMessage = err.error.message;
				if (err.status == 401) {
					this.logout();
				}
				else if (err.status == 500) {
					this.logout();
				}
			}
		)
	}
	setLoaded(during: number = 0) {
		setTimeout(() => this.store.dispatch(new PageActions.Update({
			loaded: true
		})), during);
	}

	allAllergensArray: any = [];
	// Function to get all the allergens of the restaurant
	getAllAllergens(restoID) {
		this.httpSv.getRestaurantAllergens(restoID).subscribe((res: any) => {
			if (res['status'] == "TRUE") {
				this.allAllergensArray = res['result'].data;
				this.allAllergensArray.sort((a:any,b:any) => {
					if(this.allergenceArray.includes(a.allergens_id)) return -1
					else return 1
				})
			}
		}, (err: any) => {
			console.log(err);
			if (err.status == 401 || err.status == 500) {
				this.logout();
			}
		})
	}


	alldietary: any[] = [];
	// Function to get all the dietary of the restaurant
	getAllRestoDietary(restoID) {
		this.httpSv.getRestaurantDietray(restoID).subscribe((res: any) => {
			if (res['status'] == 'TRUE') {
				this.alldietary = res['result'].data;
				this.alldietary.sort((a:any,b:any) => {
					if(this.diestPrefArray.includes(a.diet_preference_id)) return -1
					else return 1
				})
			}
		}, (err: any) => {
			if (err.status == 401 || err.status == 500) {
				this.logout();
			}
			console.log(err);
		})
	}
	hideSpiceTollrace:boolean = true
	getHideSpiceTollranceCheck(restoId){
		this.httpSv.getHideSpiceTolleranceCheck(restoId).subscribe((res: any) => {
			if (res['status']) {
				this.hideSpiceTollrace = res['result'].hide_spice_tolerance ? true : false;
				// this.hideSpiceTollrace = true;
			}
		}, (err: any) => {
			if (err.status == 401 || err.status == 500) {
				this.logout();
			}
			console.log(err);
		})
	}
	backToFoodMenu() {
		// this.router.navigate(['/horizontal/food-menu']);
		if (!sessionStorage.getItem('access_token'))
			this.router.navigate(['/public/food-menu']);
		else {
			this.router.navigate(['/horizontal/food-menu']);
		}
	}

	//   Function to update the user preferences
	updateUserPreferences() {
		if (!sessionStorage.getItem('access_token')) {
			this.httpSv.allergenceArray = this.allergenceArray
			this.httpSv.diestPrefArray = this.diestPrefArray
			this.httpSv.spiceTollerence = this.spiceTollerence
			this.httpSv.showPrefChoseFlag = false
			this.router.navigate(['/public/food-menu'])
		}
		else {
			let userPreferenceObj = {
				allergens: this.allergenceArray,
				dietary: this.diestPrefArray,
				spice: this.spiceTollerence,
				screen: "menu"
			}
			this.httpSv.postUserPreferences(userPreferenceObj).subscribe((res: any) => {
				if (res['status'] == 'TRUE') {
					this.router.navigate(['/horizontal/food-menu'])
				}
			}, (err: any) => {
				console.log(err);
				if (err.status == 401 || err.status == 500) {
					this.logout();
				}
			})
		}
	}

	foodAllergenss
	foodAllnss: any[] = []
	userAllergens = []
	allergensarry = []
	fetchedUserPreferences
	load: boolean = false;
	user_preferences: any;
	user_preference_spice: any;
	userIngredients: any;
	userDislikes: any;
	userDietary: any;
	dietaryarry = [];
	ingredientbind = [];
	userDislikesbind = [];
	user_ingredients: [];
	allAllergens = [];
	FetchUserPrefernces() {
		this.httpSv.getUserPreferences().subscribe((res: any) => {
			if (res['status'] == "TRUE") {
				this.fetchedUserPreferences = res['result'].data;
				this.userAllergens = this.fetchedUserPreferences.user_preference_allergens;
				this.userDietary = this.fetchedUserPreferences.user_preference_dietary;
				this.spiceTollerence = this.fetchedUserPreferences.user_preference_spice;
				if (Array.isArray(this.userAllergens)) {
					this.userAllergens.forEach(element => {
						this.allergenceArray.push(element.allergens_id)
					})
					this.setAllergenceActiveClass()
				}
				else {
					this.allergensarry = []
				}
				if (Array.isArray(this.userDietary)) {
					this.userDietary.forEach(element => {
						this.diestPrefArray.push(element.diet_preference_id)
					})
					this.setActiveClass()
				}
				else {
					this.userDietary = []
				}
			}
		}, (err: any) => {
			console.log(err);
			if (err.status == 401 || err.status == 500) {
				this.logout();
			}
		})

	}
}